import { getFranchiseOrganizationId } from '../shared/franchiseFlowAuth';
import { normalizeSalonGuestGender } from '../salon/utils/bootstrapFaceSalonSession';
import { PRESENTATION_CUSTOMER_GENDER } from './presentationConfig';
import { isPresentationMode } from './presentationSession';

/** Presentation kiosk always shows service + product recommendation steps when org flags are off. */
export function isPresentationRecommendationOverride() {
  return isPresentationMode();
}

export function resolvePresentationOrganizationId(fallback = null) {
  return getFranchiseOrganizationId() || fallback || null;
}

/** `male` | `female` | null — presentation defaults to configured demo guest gender. */
export function resolvePresentationGuestGenderForApi(rawGender = '') {
  if (isPresentationMode()) {
    return normalizeSalonGuestGender(PRESENTATION_CUSTOMER_GENDER) || 'female';
  }
  const normalized = normalizeSalonGuestGender(rawGender);
  return normalized || null;
}
